<template>
  <div id="app" class="container">
    <Intro v-if="screen === 'intro'"/>
    <JoinGame v-if="screen === 'join-game'"/>
    <Game v-if="screen === 'game'"/>
    <GameReviewing v-if="screen === 'game-reviewing'"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Intro from "./components/Intro";
import JoinGame from "./components/JoinGame";
import Game from "./components/Game";
import GameReviewing from "./components/GameReviewing";

export default {
  name: "App",
  components: {
    Intro,
    JoinGame,
    Game,
    GameReviewing
  },
  computed: {
    ...mapGetters(["screen"])
  }
};
</script>

<style>
html {
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
}
body {
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  background: black;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Roboto";
  /* overflow: hidden; */
}
.container {
  max-width: 450px;
  max-height: 850px;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  background: #111023;
}

.button {
  height: 50px;
  padding: 0 30px 0 30px;
  border: none;
  background: none;
  border-radius: 5px;
  color: white;
  font-size: 15px;
  font-weight: 700;
  background: #3D3896;
}
.button:disabled {
  opacity: 0.5;
}
.tip {
  font-weight: 300;
  font-size: 15px;
  color: #605E84;
  text-align: center;
  padding: 50px 40px 20px;
  text-transform: none;
}
</style>
